import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
export function PageHydration() {
  return <Page pageNumber={20} variant="light" data-id="element-1001">
      <div className="flex flex-col h-full" data-id="element-1002">
        {/* Hero image */}
        <div className="relative h-[240px] -mx-12 -mt-10 mb-8 overflow-hidden" data-id="element-1003">
          <img src="https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=1000&q=80" alt="Glass of water" className="w-full h-full object-cover" data-id="element-1004" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1005" />
          <div className="absolute bottom-4 left-12" data-id="element-1006">
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-1007">
              <span className="text-tealslate" data-id="element-1008">Hydration</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8 max-w-lg" data-id="element-1009">
          GLP-1 medications blunt your thirst mechanism just like they blunt
          your appetite. You will not feel thirsty even when you are dehydrated.
          You have to drink water intentionally.
        </p>

        <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-1010">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1011">
            <div className="flex items-center gap-2 mb-3" data-id="element-1012">
              <AlertTriangleIcon className="w-4 h-4 text-[#C4956A]" data-id="element-1013" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-1014">
                Signs of Dehydration
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-1015">
              {['Headaches', 'Fatigue', 'Dizziness', 'Constipation', 'Dark urine'].map((s, i) => <li key={i} className="flex items-center gap-2 text-xs text-[#3B3B3B]" data-id="element-1016">
                  <span className="w-1.5 h-1.5 bg-tealslate rounded-full" data-id="element-1017" />
                  {s}
                </li>)}
            </ul>
          </div>
          <div className="bg-tealslate/10 border border-tealslate/20 p-5" data-id="element-1018">
            <div className="flex items-center gap-2 mb-3" data-id="element-1019">
              <CheckCircle2Icon className="w-4 h-4 text-tealslate" data-id="element-1020" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-1021">
                Practical Tips
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-1022">
              {['Carry a water bottle everywhere', 'Drink a glass before every meal', 'Flavor with lemon or lime if needed'].map((s, i) => <li key={i} className="flex items-start gap-2 text-xs text-[#3B3B3B]" data-id="element-1023">
                  <span className="w-1.5 h-1.5 bg-tealslate rounded-full mt-1 shrink-0" data-id="element-1024" />
                  {s}
                </li>)}
            </ul>
          </div>
        </div>

        <SupplementCallout title="Electrolytes" description="Reduced food intake means fewer electrolytes from meals. An electrolyte supplement helps maintain sodium, potassium, and magnesium levels." data-id="element-1025" />
      </div>
    </Page>;
}